<form #languageTranslationForm='ngForm'>
  @if (translationSections) {
    <div #translationsTable class="translations-table-wrapper cpq-scroll">
      <table class="translations-table fiori3-table">
        <thead>
          <tr>
            <th class="sticky info-column">{{ header.labelKey | translate }}</th>
            <th class="sticky info-column">
              {{defaultDictionaryOnDomain}}
              ({{ header.defaultLanguageKey | translate }})
            </th>
            @for (dictionary of selectedDictionaries; track dictionary) {
              <th class="sticky dictionary-column">
                <div class="flex-center">
                  <cpq-select #languagesDropdown [attr.id]="'dictionaryLanguage_' + dictionary.id"
                    [ngModel]='dictionary.id' [items]='availableDictionaryItems[dictionary.id] || []'
                    (ngModelChange)='selectLanguage($event,dictionary)'
                    [name]="'languages' + dictionary.id">
                  </cpq-select>
                  @if (selectedDictionaries.length > 1) {
                    <span (click)='removeTranslationColumn(dictionary.id)'
                      class="sap-icon">&#xe03e;
                    </span>
                  }
                </div>
              </th>
            }
            @if (canAddTranslation) {
              <th class="add-new-translation-column" #addTranslationButton>
                <span class="flex-center">
                  <span id="addNewTranslationColumnIcon"
                    [style.visibility]="canAddTranslation ? 'visible' : 'hidden'"
                  (click)="addNewTranslationColumn()" class="sap-icon">&#xe058;</span>
                </span>
              </th>
            }
          </tr>
        </thead>
        <tbody>
          @for (section of translationSections; track section) {
            @if (section.labelKey) {
              <tr class="table-section-title">
                <td>{{ section.labelKey | translate }}</td>
                <td></td>
                <td [attr.colspan]="selectedDictionaries.length"></td>
              </tr>
            }
            @for (translationField of section.translationFields; track translationField) {
              <tr>
                <td>
                  {{ translationField.key | translate }}
                </td>
                <td>
                  {{ translationField.defaultValue }}
                </td>
                @for (dictionary of selectedDictionaries; track dictionary; let i = $index) {
                  <td>
                    @if (dictionary.id && dictionary.id !== emptyLanguageOption.id) {
                      @switch (translationField.type) {
                        @case (controlType.TextBox) {
                          <cpq-input-error #textbox="ngModel"
                            [attr.id]="translationField.idPrefix + dictionary.id" [control]="textbox"
                            [(ngModel)]='translationField.translations[dictionary.id]'
                            maxlength="{{translationField.maxlength}}"
                            [name]="translationField.namePrefix + i">
                          </cpq-input-error>
                        }
                        @case (controlType.TextArea) {
                          <cpq-textarea #textArea="ngModel"
                            [attr.id]="translationField.idPrefix + dictionary.id"
                            [name]="translationField.namePrefix + i" [control]="textArea"
                            [(ngModel)]='translationField.translations[dictionary.id]' [rows]="2"
                            maxlength="1000">
                          </cpq-textarea>
                        }
                        @case (controlType.FormulaBuilder) {
                          <cpq-textarea class="formula-builder"
                            #formulaBuilder="ngModel" [attr.id]="translationField.idPrefix + dictionary.id"
                            [name]="translationField.namePrefix + i" [control]="formulaBuilder"
                            [config]="fbConfig" [(ngModel)]='translationField.translations[dictionary.id]'
                            maxlength="3000">
                          </cpq-textarea>
                        }
                      }
                    }
                  </td>
                }
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  }
</form>
